var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRead = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 18 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "rect-1",
    width: 18,
    height: 18,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    x: 0,
    y: 0,
    fill: "black"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "white",
    xlinkHref: "#rect-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "none",
    xlinkHref: "#rect-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 5C6.27272701 5 3.94363642 6.65866661 3 9c.94363642 2.34133339 3.27272701 4 6 4s5.05636406-1.65866661 6-4c-.94363594-2.34133339-3.27272701-4-6-4zm0 6.66666698c-1.50545406 0-2.72727251-1.19466686-2.72727251-2.66666698S7.49454594 6.3333335 9 6.3333335c1.50545502 0 2.72727299 1.19466638 2.72727299 2.6666665S10.50545502 11.66666698 9 11.66666698zM7.36363602 9c0-.88533401.73090934-1.60000038 1.63636398-1.60000038.90545464 0 1.63636303.71466637 1.63636303 1.60000038 0 .88533306-.7309084 1.59999943-1.63636303 1.59999943-.90545464 0-1.63636398-.71466637-1.63636398-1.59999943z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRead);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "read.12b9fbed0441a1117817501ee8537c7e.svg";